module.exports = __webpack_public_path__ + "static/media/3.24_preview.9974d8d2.png";